export enum CardControlActionTypes {
  setActive = '[Administration] [CardControl] Device set active to register',
  setInactive = '[Administration] [CardControl] Device set inactive to register',
}
